import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { ReactNode } from 'react'
import { SxProps, Theme } from '@mui/material'

interface BasicModalProps {
    children: ReactNode
    isOpen: boolean
    setIsModalOpen?: (value: boolean) => void
    styles?: SxProps<Theme>
}

export default function BasicModal({
    children,
    isOpen,
    setIsModalOpen,
    styles = {},
}: BasicModalProps) {
    const handleClose = () => {
        setIsModalOpen && setIsModalOpen(false)
    }
    const basicStyle: SxProps<Theme> = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 'min-content',
        width: 'max-content',
        maxWidth: '400px',
        backgroundColor: 'custom.dropDownBackground',
        border: '0 !important',
        boxShadow: 24,
        borderRadius: '10px',
        '&:focus-visible': {
            outline: 0,
        },
        display: 'flex',
        alignItems: 'end',
        padding: '16px',
        flexDirection: 'column',
        overflow: 'auto',
    }
    return (
        <Modal
            data-testid="modal-box"
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={{ ...basicStyle, ...styles }}>{children}</Box>
        </Modal>
    )
}
